import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { authTypeOptionsConstant } from 'src/app/constants/service.constants';
import { CONFIGURATION, SAML } from 'src/app/models/common';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import * as $ from 'jquery';
import { CommonService } from 'src/app/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-saml-sso-configuration',
  templateUrl: './saml-sso-configuration.component.html',
  styleUrls: ['./saml-sso-configuration.component.scss']
})
export class SamlSsoConfigurationComponent implements OnInit {

  formFields;
  chooseoptions = authTypeOptionsConstant;
  samlSsoConfigurationForm = new UntypedFormGroup({});
  operations = [];
  mail: CONFIGURATION;
  samlconfig: SAML;

  constructor(
    private summaryService: AdministrationSummaryService,
    private modalService : NgbModal,
    private appFunctions: AppFunctionsService,
    private commonService: CommonService,
  ) { }

  ngOnInit() {
    this.samlconfig = new SAML();
    this.setForm(this.samlconfig);

    // this.criteriaService.getSamlSsoConfigCriteria().subscribe(criteria => {
    //   this.formFields = criteria.formFields;
    //   //this.appFunctions.getFormStructure(this.samlSsoConfigurationForm, this.formFields);
    //   this.operations = criteria.operations.map(operation => {
    //     return operation && operation.id === 'test_connection' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    //   });
    // });

    this.summaryService.getConfiguration('api/configuration/getsamlconfig').subscribe((result) => {
      this.mail = result;
      this.setForm(this.mail.SAML);
    });
  }

  private setForm(result: SAML): void {

    this.samlSsoConfigurationForm = new UntypedFormGroup({
      ID: new UntypedFormControl(result.ID),
      SIGNINURL: new UntypedFormControl(result.SIGNINURL),
      SIGNOUTURL: new UntypedFormControl(result.SIGNOUTURL),
      CERTIFICATE: new UntypedFormControl(result.CERTIFICATE),
      ACSURL: new UntypedFormControl(result.ACSURL),
      LOGINURL: new UntypedFormControl(result.LOGINURL),
      ENABLED: new UntypedFormControl(result.ENABLED),
      USERID: new UntypedFormControl(result.USERID),
      PASSWORD: new UntypedFormControl(result.PASSWORD)
    })
  }

  private getForm(): SAML {
    const formModel = this.samlSsoConfigurationForm.value;
    let email = new SAML();
    email = {
      ID: formModel.ID,
      SIGNINURL: formModel.SIGNINURL,
      SIGNOUTURL: formModel.SIGNOUTURL,
      CERTIFICATE: formModel.CERTIFICATE,
      ACSURL: formModel.ACSURL,
      LOGINURL: formModel.LOGINURL,
      ENABLED: formModel.ENABLED,
      USERID: formModel.USERID,
      PASSWORD: formModel.PASSWORD
    }

    return email;
  }


  onCallbackOperation(opr){
    opr.callback();
  }

  test_connection(){
    this.commonService.SuccessBanner("Connection working properly");
    //this['self'].modalService.show(MessageBoxComponent, {data:{heading:'Test Connection',content: { heading: '', description: 'Connection working properly.'}}});
  }
  

  save() {
    if (this.validateControls()) {
      this.mail.SAML = this.getForm();
      this.summaryService.saveSAMLconfiguration(this.mail).subscribe(result => {
        if (result.Status === 0) {
          this.commonService.SuccessBanner("SAML Configuration Saved Successfully");
          //this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: 'SAML Configuration Saved Successfully.' } } });
        }
        else {
          this.commonService.ValidationBanner(result.Message);
          //this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: result.Message } } });
        }
      });
    }
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.samlSsoConfigurationForm.value;

    // Representative validations
    if (formData.SIGNINURL === null || formData.SIGNINURL === "" || formData.SIGNINURL === undefined) {
      $("#SIGNINURL").addClass("ng-touched ng-invalid validate-error");
      $("#SIGNINURL").removeClass("ng-untouched ng-valid");
      message += "Please enter Sign-In URL<br/>";
      isValid = false;
    } else {
      $("#SIGNINURL").addClass("ng-untouched ng-valid");
      $("#SIGNINURL").removeClass("ng-touched ng-invalid validate-error");
    }


    // Representative validations
    if (formData.SIGNOUTURL === null || formData.SIGNOUTURL === "" || formData.SIGNOUTURL === undefined) {
      $("#SIGNOUTURL").addClass("ng-touched ng-invalid validate-error");
      $("#SIGNOUTURL").removeClass("ng-untouched ng-valid");
      message += "Please enter  Sign-Out URL<br/>";
      isValid = false;
    } else {
      $("#SIGNOUTURL").addClass("ng-untouched ng-valid");
      $("#SIGNOUTURL").removeClass("ng-touched ng-invalid validate-error");
    }


    // Representative validations
    if (formData.USERID === null || formData.USERID === "" || formData.USERID === undefined) {
      $("#USERID").addClass("ng-touched ng-invalid validate-error");
      $("#USERID").removeClass("ng-untouched ng-valid");
      message += "Please enter UserID<br/>";
      isValid = false;
    } else {
      $("#USERID").addClass("ng-untouched ng-valid");
      $("#USERID").removeClass("ng-touched ng-invalid validate-error");
    }


    // Representative validations
    if (formData.PASSWORD === null || formData.PASSWORD === "" || formData.PASSWORD === undefined) {
      $("#PASSWORD").addClass("ng-touched ng-invalid validate-error");
      $("#PASSWORD").removeClass("ng-untouched ng-valid");
      message += "Please enter Password<br/>";
      isValid = false;
    } else {
      $("#PASSWORD").addClass("ng-untouched ng-valid");
      $("#PASSWORD").removeClass("ng-touched ng-invalid validate-error");
    }


    // Representative validations
    if (formData.CERTIFICATE === null || formData.CERTIFICATE === "" || formData.CERTIFICATE === undefined) {
      $("#CERTIFICATE").addClass("ng-touched ng-invalid validate-error");
      $("#CERTIFICATE").removeClass("ng-untouched ng-valid");
      message += "Please enter Validate Certificate<br/>";
      isValid = false;
    } else {
      $("#CERTIFICATE").addClass("ng-untouched ng-valid");
      $("#CERTIFICATE").removeClass("ng-touched ng-invalid validate-error");
    }


    // Representative validations
    if (formData.ACSURL === null || formData.ACSURL === "" || formData.ACSURL === undefined) {
      $("#ACSURL").addClass("ng-touched ng-invalid validate-error");
      $("#ACSURL").removeClass("ng-untouched ng-valid");
      message += "Please enter ACS URL<br/>";
      isValid = false;
    } else {
      $("#ACSURL").addClass("ng-untouched ng-valid");
      $("#ACSURL").removeClass("ng-touched ng-invalid validate-error");
    }


    // Representative validations
    if (formData.LOGINURL === null || formData.LOGINURL === "" || formData.LOGINURL === undefined) {
      $("#LOGINURL").addClass("ng-touched ng-invalid validate-error");
      $("#LOGINURL").removeClass("ng-untouched ng-valid");
      message += "Please enter Login URL<br/>";
      isValid = false;
    } else {
      $("#LOGINURL").addClass("ng-untouched ng-valid");
      $("#LOGINURL").removeClass("ng-touched ng-invalid validate-error");
    }



    if (!isValid)
    this.commonService.ValidationBanner(message);
      //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: message } } });
    return isValid;
  }


}
